import { render, staticRenderFns } from "./CustomCarousel.vue?vue&type=template&id=57e12ed3&scoped=true"
import script from "./CustomCarousel.vue?vue&type=script&lang=js"
export * from "./CustomCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e12ed3",
  null
  
)

export default component.exports